import { useState } from "react";
import { BarChart3, LogOut, Mail, MessageCircle, Settings, Users } from "lucide-react";
import { Logo } from "../../components/site/Logo";
import AnalyticsTab from "./AnalyticsTab";
import LeadsTab from "./LeadsTab";
import WhatsAppTab from "./WhatsAppTab";
import EmailLogsTab from "./EmailLogsTab";
import TemplatePanel from "./TemplatePanel";

const TABS = [
  ["analytics", "Analytics", BarChart3, AnalyticsTab, "admin-analytics-nav"],
  ["leads", "Lead pipeline", Users, LeadsTab, "admin-leads-nav"],
  ["whatsapp", "WhatsApp clicks", MessageCircle, WhatsAppTab, "admin-whatsapp-nav"],
  ["emails", "Email logs", Mail, EmailLogsTab, "admin-emails-nav"],
  ["template", "Email template", Settings, TemplatePanel, "admin-template-nav"],
];

export default function Admin({ user, onLogout }) {
  const [tab, setTab] = useState("analytics");
  const [, label, , Active] = TABS.find((t) => t[0] === tab);
  const nav = (prefix) => TABS.map(([id, l, Icon, , testId]) => (
    <button key={id} className={tab === id ? "side-active" : ""} onClick={() => setTab(id)} data-testid={prefix ? `${prefix}-${id}` : testId}><Icon /> {l}</button>
  ));
  return (
    <main className="admin-shell">
      <aside className="admin-sidebar">
        <Logo compact />
        <div className="admin-user"><span className="avatar">MF</span><div><strong>{user?.name || "ML FAB Admin"}</strong><small>Administrator</small></div></div>
        <div className="sidebar-label">Workspace</div>
        <nav className="side-nav">{nav()}</nav>
        <button className="side-logout" onClick={onLogout} data-testid="admin-logout-button"><LogOut /> Sign out</button>
      </aside>
      <section className="admin-content">
        <div className="admin-mobile-tabs">{nav("mobile-tab")}<button onClick={onLogout} data-testid="mobile-logout-button"><LogOut /> Sign out</button></div>
        <p className="eyebrow">Operations console / {label}</p>
        <Active />
      </section>
    </main>
  );
}
